import { TThemeElevations } from './TThemeElevations';
import { elevations } from './ebds-elevations.json';

export const lightThemeElevations: TThemeElevations = elevations.light;
export const darkThemeElevations: TThemeElevations = elevations.dark;
